import { z } from "zod";
export const schemaDeviceType = z.enum([
    "blue",
    "nanoS",
    "nanoSP",
    "nanoX",
    "stax",
    "europa",
]);
//# sourceMappingURL=Device.js.map